import React from "react";
import StepSlider from "../../components/StepSlider";
import { StyledSectionWrapper } from "./ui";
const sliderData = [
  {
    image: "Section 4- 1.png",
    title: "List your Home facility",
    description:
      "Exsportia is simple and easy to use, follow the simple 10 minute setup plan to quickly list your space."
  },
  {
    image: "Section 4- 2.png",
    title: "Manage on your device",
    description:
      "We know how “on the go” life has become so we made packed all our features into a mobile version so you can run your sports business from your pocket"
  },
  {
    image: "Section 4- 3.png",
    title: "For your community",
    description:
      "Join Exsportia’s initiative in making sports local and accessible. Choose from thousands of options. Not sure which sports to bring to your area ? Get in touch and we can help."
  },
  {
    image: "Section 4- 4.png",
    title: "Airbnb for sports",
    description:
      "Turn any available space into a profitable sports business. Start your sports business today"
  }
];

const MobileVMS = () => {
  return (
    <StyledSectionWrapper>
      <p>Playing sports and activities never easier</p>
      <h2>Mobile VMS - mangage on the go </h2>
      <StepSlider data={[...sliderData]} color="greenWhite" />
    </StyledSectionWrapper>
  );
};

export default MobileVMS;
